class ModalPost {
  constructor() {
    const modalIframeArticle = document.querySelector('.modal__box--article__iframe');
    const readMores = document.querySelectorAll('.read-more--article');
    const modalArticle = document.querySelector('.modal__box--article');
    const modalClose = document.querySelector('.modal__close--article');
    const modalCloseBar = document.querySelector('.modal__box--article__barholder');
    // const modalClose = modalIframeArticle.contentWindow.document.getElementsByClassName(".modal__close--article")[0];

    // console.log(modalCloseBar);
    
    readMores.forEach(readMore => {
      readMore.addEventListener("click", () => {

        const articleSrc = readMore.getAttribute('data-postlink');
        
        document.querySelector('body').style.overflow = 'hidden';

        document.querySelector('.modals').classList.add('act');
        document.querySelector('.modal__box--article').classList.add('act');

        document.querySelector('.modal__box--article__iframe').setAttribute('src', articleSrc);
        document.querySelector('.modal__box--article__iframe').classList.add('act');

      });
    });

    modalClose.addEventListener('click', () => {
      document.querySelector('body').style.overflow = 'auto';
      document.querySelector('.modals').classList.remove('act');
      document.querySelector('.modal__box--article__iframe').setAttribute('src', '');
      document.querySelector('.modal__box--article__iframe').classList.remove('act');
      document.querySelector('.modal__box--article').classList.remove('act');
    });

    modalCloseBar.addEventListener('click', () => {
      document.querySelector('body').style.overflow = 'auto';
      document.querySelector('.modals').classList.remove('act');
      document.querySelector('.modal__box--article__iframe').setAttribute('src', '');
      document.querySelector('.modal__box--article__iframe').classList.remove('act');
      document.querySelector('.modal__box--article').classList.remove('act');
    });

    modalArticle.addEventListener("click", (e) => e.stopPropagation());
  }
}
export default ModalPost
